import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger
} from "@/components/ui/select";
import { cn } from "@/lib/class-control";
import { Dispatch, ReactNode, SetStateAction } from "react";
import { TFocus } from "./input";

interface DropdownOptions {
  id: string;
  label: ReactNode;
}

interface DropdownProps {
  options: DropdownOptions[]
  selected: string
  onChange?: Dispatch<SetStateAction<string>>
  focus?: TFocus
  classNameContainer?: string
}

export function Dropdown(props: DropdownProps) {

  return (
    <div className={cn("w-full", props.classNameContainer)}>
      <Select value={props.selected} onValueChange={value => props.onChange?.(value)}>
        <SelectTrigger focus={props.focus} className="text-purple-50 h-input-slim px-4 py-2 transition-colors">
          <div className="flex items-center gap-2">
            <span className="font-medium text-sm text-purple-50 truncate">
              {props.options.find(f => f.id === props.selected)?.label}
            </span>
          </div>
        </SelectTrigger>
        <SelectContent className="bg-darkblue">
          {props.options.map((option, idx) => (
            <SelectItem
              key={idx}
              value={option.id}
              className="text-purple-50 cursor-pointer"
            >
              <span className="truncate">{option.label}</span>
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}
